import {HttpClient} from '@angular/common/http';
import {map, shareReplay} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PhrasesDictionary, StartPhrase} from '../models/models';
import {LUMII_API, RT_API} from './app.interceptor';
import {UiService} from "./ui.service";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  phrasesDictionary: PhrasesDictionary = {};
  languages: {langCode: string, langName: string}[] = [
    {langCode: 'en', langName: 'english'},
    {langCode: 'ar', langName: 'العربية'},
    {langCode: 'zh-CN', langName: '普通话'},
    {langCode: 'zh-TW', langName: '粵語'},
    {langCode: 'uk', langName: 'українська'},
    {langCode: 'ru', langName: 'русский'},
    {langCode: 'sq', langName: 'shqip'},
    {langCode: 'am', langName: 'አማርኛ'},
    {langCode: 'bn', langName: 'বাংলা'},
    {langCode: 'bg', langName: 'български'},
    {langCode: 'cs', langName: 'čeština'},
    {langCode: 'fr', langName: 'français'},
    {langCode: 'it', langName: 'italiano'},
    {langCode: 'lt', langName: 'lietuvių'},
    {langCode: 'ml', langName: 'മലയാളം'},
    {langCode: 'pl', langName: 'polski'},
    {langCode: 'pt', langName: 'português'},
    {langCode: 'ro', langName: 'română'},
    {langCode: 'sn', langName: 'chiShona'},
    {langCode: 'si', langName: 'සිංහල'},
    {langCode: 'sk', langName: 'slovenčina'},
    {langCode: 'es', langName: 'español'},
    {langCode: 'ta', langName: 'தமிழ்'},
    {langCode: 'tr', langName: 'türkçe'},
    {langCode: 'yo', langName: 'Èdè Yorùbá'},

    // {langCode: 'ak', langName: 'Akan'}
  ];

  countries$ = this.getCountries().pipe(shareReplay(1));
  currencies$ = this.getCurrencies().pipe(shareReplay(1));

  constructor(private httpClient: HttpClient,
              private translateService: TranslateService,
              private uiService: UiService) {
  }

  getStartPhrases() {
    return this.phrasesDictionary[this.getLang()].sort((a, b) => a.id > b.id ? 1 : -1);
  }

  getLang() {
    return localStorage.getItem('lang') || 'en';
  }

  getSavedLang() {
    return localStorage.getItem('lang');
  }

  async initialize() {
    this.uiService.setGlobalLoadingMessage('Loading language pack...');
    try {
      await this.loadStartPhrases().toPromise();
      this.uiService.setGlobalLoadingMessage('Loading resources...');
    } catch (error) {
      console.error(error);
      this.uiService.setGlobalErrorState('Something went wrong. Please reload the page');
    }
  }

  isRtl() {
    return this.getLang() === 'ar';
  }

  setLang(lang: string) {
    localStorage.setItem('lang', lang);
    this.translateService.setDefaultLang(lang || 'en');
  }

  loadStartPhrases() {
    return this.httpClient.get<StartPhrase[]>(`${LUMII_API}/api/lumii/start_phrases`).pipe(
      map(phrases => phrases.forEach(phrase => {
        // phrase.lang === lang
        this.phrasesDictionary[phrase.lang] = [...this.phrasesDictionary[phrase.lang] || [], phrase];
      })),
    );
  }

  getCountries(all = 'NO') {
    return this.httpClient.get<any[]>(`${RT_API}/api/Utils/GetCountries?all=${all}`);
  }

  // GetCurrencies
  getCurrencies() {
    return this.httpClient.get<any[]>(`${RT_API}/api/Utils/GetCurrencies`);
  }

}
